export const BRAND_THEME_KEY = 'aamalBlue' as const;

export const DEFAULT_PALETTE_ID = 'aa219282-77d7-4005-8f79-59fe9582930d';
export const DEFAULT_PALETTE_NAME = 'AAMAL Blue';

export interface BrandPaletteDefaults {
  preview: string;
  appThemeEl23Light: string;
  appThemeEl23Dark: string;
  appThemeG900Light: string;
  appThemeG900Dark: string;
  pulseRateColor: string;
  temperatureColor: string;
  spO2Color: string;
  respiratoryRateColor: string;
  bloodPressureColor: string;
  bloodPressure2Color: string;
  pulseRateAreaStartColor: string;
  pulseRateAreaEndColor: string;
  temperatureAreaStartColor: string;
  temperatureAreaEndColor: string;
  spO2AreaStartColor: string;
  spO2AreaEndColor: string;
  respiratoryRateAreaStartColor: string;
  respiratoryRateAreaEndColor: string;
  bloodPressureAreaStartColor: string;
  bloodPressureAreaEndColor: string;
  bloodPressure2AreaStartColor: string;
  bloodPressure2AreaEndColor: string;
  toastColor: string;
}

export const BRAND_PALETTE_DEFAULTS: BrandPaletteDefaults = {
  preview: '#1686C8',
  appThemeEl23Light: '#1686C8',
  appThemeEl23Dark: '#126B9E',
  appThemeG900Light: '#17374A',
  appThemeG900Dark: '#F2F8FC',
  pulseRateColor: '#CE081C',
  temperatureColor: '#7FBE54',
  spO2Color: '#5BABF8',
  respiratoryRateColor: '#FFC107',
  bloodPressureColor: '#77787A',
  bloodPressure2Color: '#1686C8',
  pulseRateAreaStartColor: 'rgba(241, 65, 108, 0.4)',
  pulseRateAreaEndColor: 'rgba(241, 65, 108, 0.1)',
  temperatureAreaStartColor: 'rgba(127, 190, 84, 0.4)',
  temperatureAreaEndColor: 'rgba(127, 190, 84, 0.1)',
  spO2AreaStartColor: 'rgba(91, 171, 248, 0.4)',
  spO2AreaEndColor: 'rgba(91, 171, 248, 0.1)',
  respiratoryRateAreaStartColor: 'rgba(255, 193, 7, 0.4)',
  respiratoryRateAreaEndColor: 'rgba(255, 193, 7, 0.1)',
  bloodPressureAreaStartColor: 'rgba(119, 120, 122, 0.4)',
  bloodPressureAreaEndColor: 'rgba(119, 120, 122, 0.1)',
  bloodPressure2AreaStartColor: 'rgba(22, 134, 200, 0.4)',
  bloodPressure2AreaEndColor: 'rgba(22, 134, 200, 0.1)',
  toastColor: '#1686C8',
};
